import { httpApi } from "../http.api";
import axios, { AxiosError } from "axios";
import { IAuthTokenResponse } from "interfaces/ApiInterface/IAuth";
import { IDashboardChartData } from "interfaces/ApiInterface/IDashboardChart";

export const getDashboardDetails = (
  portalId: number,
  days: string
): Promise<IDashboardChartData> => {
  return httpApi
    .get(`/bstoreswebstore/getdashboarddetails/${portalId}/${days}`)
    .then((res: IDashboardChartData) => res)
    .catch((err: AxiosError) => {
      throw err;
    });
};

/** @param Authentication api call */
const input = `${process.env.REACT_APP_API_DOMAIN_NAME}|${process.env.REACT_APP_API_DOMAIN_KEY}`;
const base64String = btoa(input);

const headers = {
  Authorization: `Basic ${base64String}`, // Example: sending an authorization token
};

export const getAuthorizationToken = (): Promise<IAuthTokenResponse> => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/token/generatetoken`, {
        headers: headers,
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
